import { render, staticRenderFns } from "./ModalEditPassword.vue?vue&type=template&id=42b2be19&scoped=true&"
import script from "./ModalEditPassword.vue?vue&type=script&lang=js&"
export * from "./ModalEditPassword.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditPassword.vue?vue&type=style&index=0&id=42b2be19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b2be19",
  null
  
)

export default component.exports